<template>
<div>
<YourAdviser/>

</div>
</template>

<script>

import YourAdviser from '../../../components/academic/Advisor/YourAdviser.vue';


export default {
  components: {
  
    YourAdviser
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>